import { Icon } from "@hireart/component-library";
import rightChevronIcon from "hireart-icons/chevron-right.svg";
import _ from "lodash";
import moment from "moment-timezone";
import { Grid, Segment } from "semantic-ui-react";

import {
  INTERVIEW_REQUEST_POST_CONFIRMED_STATES,
  INTERVIEW_REQUEST_CONFIRMED_STATES,
} from "common/helpers/interviewRequest";

import CandidateAvatar from "../../../Managers/Hiring/components/Candidate/Avatar";
import SegmentHeader from "./SegmentHeader";

const InterviewsUpcoming = ({ interviewRequests }) => {
  const allConfirmedStatuses =
    INTERVIEW_REQUEST_POST_CONFIRMED_STATES +
    INTERVIEW_REQUEST_CONFIRMED_STATES;
  const currentTime = moment().tz(moment.tz.guess());
  const upcomingInterviews = _.filter(
    interviewRequests,
    (request) =>
      _.includes(allConfirmedStatuses, request.step) &&
      currentTime.isBefore(
        moment.unix(request.start_time).tz(moment.tz.guess())
      )
  );

  return (
    <Segment.Group>
      <SegmentHeader
        icon="comments"
        title="Upcoming interviews"
        labelCount={upcomingInterviews.length}
      />
      {upcomingInterviews.map((request) => {
        const interviewDurationHours = request.duration / 60 / 60;

        return (
          <Segment key={request.id}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3}>
                  <CandidateAvatar
                    profile_picture_url={
                      request.membership.unified_app.user.profile_picture_url
                    }
                    size={65}
                  />
                </Grid.Column>
                <Grid.Column width={13}>
                  <div className="flex items-start justify-between">
                    <h2>{request.membership.unified_app.user.full_name}</h2>
                    <a
                      href={`/managers/hiring/candidate/${request.membership.slug}`}
                      className="flex items-center space-x-2"
                    >
                      <span>View profile</span>
                      <Icon src={rightChevronIcon} className="h-16 w-16" />
                    </a>
                  </div>
                  <p>
                    Confirmed for{" "}
                    {moment
                      .unix(request.start_time)
                      .tz(moment.tz.guess())
                      .format("M/D/YY [at] hh:mm a z")}
                    <br />
                    {`${interviewDurationHours} hour ${request.interview_type} interview`}
                  </p>
                  <p className="is-gray">
                    Interviewing for {request.membership.job.name}
                  </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        );
      })}
    </Segment.Group>
  );
};

export default InterviewsUpcoming;
